import React, { useState, useEffect } from 'react';
import { ProductFilters as Filters } from '@/infrastructure/repositories';
import { categoryService, productService } from '@/application/services';
import { Category } from '@/domain/entities';

interface ProductFiltersProps {
  filters: Filters;
  onChange: (filters: Partial<Filters>) => void;
  onReset: () => void;
}

export const ProductFilters: React.FC<ProductFiltersProps> = ({
  filters,
  onChange,
  onReset,
}) => {
  const [search, setSearch] = useState(filters.search || '');
  const [categories, setCategories] = useState<Category[]>([]);
  const [brands, setBrands] = useState<string[]>([]);
  const [brandInput, setBrandInput] = useState(filters.brand || '');
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | undefined>(
    filters.categoryId
  );

  useEffect(() => {
    categoryService.getCategories().then(setCategories).catch(console.error);
    productService.getBrands().then(setBrands).catch(console.error);
  }, []);

  const handleSearchChange = (value: string) => {
    setSearch(value);
    onChange({ search: value || undefined, offset: 0 });
  };

  const handleCategoryChange = (categoryId: number | '') => {
    const id = categoryId === '' ? undefined : categoryId;
    setSelectedCategoryId(id);
    onChange({ categoryId: id, offset: 0 });
  };

  const handleBrandChange = (brand: string) => {
    setBrandInput(brand);
    onChange({ brand: brand || undefined, offset: 0 });
  };

  return (
    <div className="bg-white dark:bg-gray-800 p-3 rounded-lg shadow border border-gray-200 dark:border-gray-700">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Поиск
          </label>
          <input
            type="text"
            value={search}
            onChange={(e) => handleSearchChange(e.target.value)}
            placeholder="Поиск по названию, бренду, артикулу..."
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Категория
          </label>
          <select
            value={selectedCategoryId || ''}
            onChange={(e) => handleCategoryChange(Number(e.target.value) || '')}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          >
            <option value="">Все категории</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.nameRu}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Бренд
          </label>
          <select
            value={brandInput}
            onChange={(e) => handleBrandChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          >
            <option value="">Все бренды</option>
            {brands.map((brand, index) => (
              <option key={index} value={brand}>
                {brand}
              </option>
            ))}
          </select>
        </div>
        <div className="flex items-end">
          <button
            onClick={onReset}
            className="w-full px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-md hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
          >
            Сбросить
          </button>
        </div>
      </div>
    </div>
  );
};

